import cn from "classnames";
import { FocusEvent, useId, useRef } from "react";
import { Flyout } from "../../../flyout";
import type { ContainerProps } from "./types";
import styles from "./styles.module.scss";

export const Container = ({
  className,
  disabled,
  expanded,
  children,
  dataTestId,
  searchComponent,
  onBlur,
}: ContainerProps) => {
  const id = useId();

  const containerRef = useRef<HTMLDivElement>(null);

  const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
    /* Определяем произошел ли ре-фокус на элемент (relatedTarget), который не является потомком родительского элемента (containerRef) */
    const isFocusOccurredOutOfSelectComponentTree =
      !event.currentTarget?.contains(event.relatedTarget) &&
      // поскольку flyout не является потомком данного компонента в DOM дереве, при всплытии события оно не будет перехвачено с помощью верхнего условия
      !document.getElementById(id)?.contains(event.relatedTarget);

    /* Если произошла смена фокуса на элемент находящийся за пределами селекта, то закрываем плашку с опциями и вызываем пользовательский onBlur */
    if (isFocusOccurredOutOfSelectComponentTree) {
      onBlur(event);
    }
  };

  const wrapperClassName = cn(
    styles.wrapper,
    {
      [styles.disabled]: disabled,
      [styles.expanded]: expanded,
    },
    className
  );

  return (
    <div
      ref={containerRef}
      data-test-id={dataTestId}
      className={wrapperClassName}
      onBlur={handleBlur}
    >
      {searchComponent}

      {expanded && (
        <Flyout
          id={id}
          parentRef={containerRef}
          className={styles.flyout}
          positionsOrder={["bottom", "top"]}
          shouldUseParentWidth
        >
          {children}
        </Flyout>
      )}
    </div>
  );
};
